import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { orderApiService } from "../../services/otodis/OrderApiService";
import { orderService } from "../../services/otodisApi/OrderService";
import { Tooltip, Button, Col, Modal, Row, Table, DatePicker, Form, Divider, Tag, Select } from "antd";
import { CloudSyncOutlined, CopyOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { ListDeliveryOrderStates } from "./types/ListDeliveryOrderTypes";
import moment from "moment";
import currencyFormat from "../../helper/currencyFormat";

export interface ListDeliveryOrderProps {}

class ListDeliveryOrder extends Component<ListDeliveryOrderProps & any, ListDeliveryOrderStates> {
  private readonly initState!: ListDeliveryOrderStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");
  private tableColumn: any = [
    {
      title: "Kode Order & Offer",
      dataIndex: "order_code",
      width: 170,
      render: (value: string, row: any) => {
        // console.log("xsxx", row);

        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
            </span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode order" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
            <br />
            <span className={`font-90`}>{`${row.amh_order_number}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "No Delivery",
      dataIndex: "order_delivery_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nama BPKB & Nama Konsumen",
      dataIndex: "customer_name",
      width: 150,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${row.customer_doc_name}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${value}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Order & Tgl Delivery",
      dataIndex: "order_create_date",
      width: 120,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${row.order_create_date}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${row.order_delivery_date}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Handover",
      dataIndex: "handover_delivery_date",
      width: 120,
      render: (value: string, row: any) => {
        if (value) {
          return (
            <React.Fragment>
              <span style={{ fontSize: "80%" }}>{`${value}`}</span>
            </React.Fragment>
          );
        } else {
          return null;
        }
      },
    },
    {
      title: "Handover Detail",
      dataIndex: "handover_deliver_detail",
      width: 120,
      render: (value: any, row: any) => {
        // console.log(value);

        return (
          <React.Fragment>
            {value?.receiver_name && value?.receiver_signature_url && (
              <span className={`font-90-link`} onClick={() => this.configModalImage(true, value?.receiver_signature_url)} style={{ cursor: "pointer", maxWidth: "100px" }}>
                {value?.receiver_name}
              </span>
            )}
            <br />
            {value?.handover_proof_url && (
              <span className={`font-90-link`} onClick={() => this.configModalImage(true, value?.handover_proof_url)} style={{ cursor: "pointer", maxWidth: "100px" }}>
                Bukti Serah
              </span>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Tipe Motor",
      dataIndex: "vehicle_variant_code",
      width: 100,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${value}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${row.vehicle_variant_name}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "PDF BAST",
      dataIndex: "order_code",
      width: 100,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            {row?.handover_delivery_date && (
              <a
                className={`font-90-link`}
                href={`https://asia-southeast1-autotrimitra.cloudfunctions.net/api-offer-otodis--create-pdf/order/generate-bast?company=amarta&order_code=${encodeURIComponent(
                  value
                )}&admin_key=amarta123456`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "80%" }}
              >
                Buka PDF
              </a>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (row: any) => {
        // console.log("CEK AMH ", row.handover_deliver_detail.id_amh);
        // console.log("CEK AMH B", row.handover_deliver_detail?.id_amh);

        if (row.handover_delivery_date) {
          if (row.handover_deliver_detail.id_amh) {
            return null;
          } else {
            if (new Date(row.handover_delivery_date) > new Date("2024-01-07")) {
              return (
                <span className={`font-90`}>
                  <Tooltip placement="topLeft" title="Kirim Ulang Data AMH">
                    <Tag icon={<UploadOutlined />} color="#4ba53b" onClick={(event) => this.resendAmh(row)} style={{ cursor: "pointer" }}>
                      Kirim Ulang Data AMH
                    </Tag>
                  </Tooltip>
                </span>
              );
            } else {
              return null;
            }
          }
        } else {
          // Jika handover_delivery_date belum ada, menampilkan tombol "Cancel"
          return (
            <span className={`font-90`}>
              <Tooltip placement="topLeft" title="Cancel Delivery Order">
                <Tag icon={<DeleteOutlined />} color="#d9534f" onClick={(event) => this.cancelOrder(row)} style={{ cursor: "pointer" }}>
                  Cancel
                </Tag>
              </Tooltip>
            </span>
          );
        }
      },
    },
  ];

  constructor(props: (ListDeliveryOrderProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      processingFetchDetailTableData: true,
      processingFetchTableData: false,
      dataOrder: [],
      pageSize: 100,
      dataDetailStock: [],
      filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
      filterStatusHandover: "ALL",
      showModalDetailStock: false,
      confirmDeleteVisible: false,
      confirmLoading: false,
      confirmText: "",
      showModalImage: false,
      modalImageUrl: "",
      confirmResendVisible: false,
      confirmResendLoading: false,
      confirmResendText: "",
    };
    this.state = { ...this.initState };
  }

  cancelOrder = (data: any) => {
    this.setState({
      confirmDeleteVisible: true,
      confirmLoading: false,
      confirmText: data.order_code,
    });
  };

  confirmOk = async () => {
    this.setState({
      confirmLoading: true,
    });

    try {
      await orderApiService
        .CancelDeliveryOrder({
          dealerCode: this.state.dealerCode,
          orderCode: this.state.confirmText,
        })
        .then(() => {
          Modal.success({
            title: "Proses Sukses",
            content: "Data berhasil dibatalkan data berhasil diupdate",
          });
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        confirmLoading: false,
      });
    }
  };

  resendAmh = (data: any) => {
    this.setState({
      confirmResendVisible: true,
      confirmResendLoading: true,
      confirmResendText: data.order_code,
    });
  };

  confirmResendOk = async () => {
    this.setState({
      confirmLoading: true,
    });

    try {
      orderService.setToken(this.token);
      await orderService
        .resendDataAmh({
          dealer_code: this.state.dealerCode,
          order_code: this.state.confirmResendText,
          updated_by: this.user,
        })
        .then(async () => {
          Modal.success({
            title: "Proses Sukses",
            content: "Berhasil Di Proses",
          });
          // setTimeout(function () {
          //   window.location.reload();
          // }, 2000);
          this.setState({
            confirmLoading: false,
            confirmResendVisible: false,
            confirmResendLoading: false,
            confirmResendText: "",
          });
        });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        confirmLoading: false,
      });
    }
  };

  confirmCancel = () => {
    this.setState({
      confirmDeleteVisible: false,
      confirmResendVisible: false,
    });
  };

  closeModalDetailStock = (data: any) => {
    this.setState({
      showModalDetailStock: false,
    });
  };

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  showDetail = async (data: any) => {
    await this.promisedSetState({
      dataDetailStock: data,
      showModalDetailStock: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });

    await this.fetchStockData();
  };

  fetchStockData = async () => {
    await this.promisedSetState({
      dataOrder: [],
      processingFetchTableData: true,
    });

    orderApiService
      .getOrder({
        dealerCode: this.state.dealerCode,
        dateStart: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
        dateEnd: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
        dataType: "delivery_date",
        statusOrder: "DELIVERED",
        handoverStatus: this.state.filterStatusHandover,
      })
      .then(async (value) => {
        await this.promisedSetState({
          dataOrder: value.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataOrder: [],
          processingFetchTableData: false,
        });
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    // console.log(pagination);
    // console.log(filters);
    // console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onWarehouseStartDate = (data: any) => {
    this.setState({
      filterStartDate: data,
    });
  };

  onWarehouseEndDate = (data: any) => {
    this.setState({
      filterEndDate: data,
    });
  };

  onHandoverStatusChange = (v: string) => {
    this.setState({
      filterStatusHandover: v,
    });
  };

  configModalImage = async (showModal: boolean, imgUrl: string) => {
    await this.promisedSetState({
      showModalImage: showModal,
      modalImageUrl: imgUrl,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Delivery`}
          breadcrumbMenu={`List Delivery Order`}
          defaultSelectedKeys={["m-list-delivery"]}
          defaultOpenKeys={["sm-delivery"]}
        >
          <div style={{ padding: 24 }}>
            <Form layout={`inline`}>
              <Form.Item className={"padTop-10"}>
                <i className={`small-text-grey`}>Tanggal</i>
                <br />
                <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseStartDate(event)} format={"YYYY-MM-DD"} />
              </Form.Item>
              <Form.Item className={"padTop-10"}>
                <br />
                <DatePicker defaultValue={moment(this.state.filterEndDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseEndDate(event)} format={"YYYY-MM-DD"} />
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ minWidth: 140 }}>
                <i className={`small-text-grey`}>Status Handover</i>
                <Select showSearch placeholder="Status Handover" optionFilterProp="children" onChange={this.onHandoverStatusChange} value={this.state.filterStatusHandover}>
                  <Select.Option key={`ALL`} value={`ALL`}>{`ALL`}</Select.Option>
                  <Select.Option key={`BELUM HANDOVER`} value={`BELUM HANDOVER`}>{`Belum Handover`}</Select.Option>
                  <Select.Option key={`SUDAH HANDOVER`} value={`SUDAH HANDOVER`}>{`Sudah Handover`}</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item className={"padTop-10"}>
                <br />
                <Button onClick={this.fetchStockData} type="primary" icon={<CloudSyncOutlined />}>
                  {" "}
                  Go{" "}
                </Button>
              </Form.Item>
            </Form>
          </div>
          <br />
          <Table
            rowKey={"order_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataOrder}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal
            visible={this.state.showModalDetailStock}
            title="Detail Order"
            onOk={this.closeModalDetailStock}
            onCancel={this.closeModalDetailStock}
            width={"50%"}
            cancelText={"Tutup"}
            okText={false}
            footer={[
              <Button key="back" type="primary" onClick={this.closeModalDetailStock}>
                Tutup
              </Button>,
            ]}
          >
            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Order</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Kode Order:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_code}</Col>
              <Col span={8} className={`col-grey`}>
                ID Order AMH:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.amh_order_number}</Col>
              <Col span={8} className={`col-grey`}>
                Tanggal Buat:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_create_date}</Col>
              <Col span={8} className={`col-grey`}>
                Tanggal Closing:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_closing_date}</Col>
              <Col span={8} className={`col-grey`}>
                Tanggal Delivery:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_delivery_date}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Dealer:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.dealer_name}</Col>
              <Col span={8} className={`col-grey`}>
                Marketing Code:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.marketing_code}</Col>
              <Col span={8} className={`col-grey`}>
                Marketing Name:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.marketing_name}</Col>
              <Col span={8} className={`col-grey`}>
                Payment Method:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_payment_method}</Col>
              <Col span={8} className={`col-grey`}>
                Status Order:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.order_status}</Col>
              <Col span={8} className={`col-grey`}>
                Kode Leasing:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.leasing_code}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Leasing:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.leasing_name}</Col>
              <Col span={8} className={`col-grey`}>
                Tanggal PO leasing:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.leasing_po_date}</Col>
            </Row>

            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Customer</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Nama pada BPKB:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.customer_doc_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor KTP:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.customer_identity_number}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Customer:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.customer_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Provinsi:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.province_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Kota:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.city_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Kecamatan:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.district_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Kelurahan:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.sub_district_name}</Col>
              <Col span={8} className={`col-grey`}>
                Alamat:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.address}</Col>
            </Row>

            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Kendaraan</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Kode Stock:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.stock_unit_code}</Col>
              <Col span={8} className={`col-grey`}>
                Merk:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_brand_name}</Col>
              <Col span={8} className={`col-grey`}>
                Model:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_model_name}</Col>
              <Col span={8} className={`col-grey`}>
                Kode Variant:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_variant_code}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Variant:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_variant_name}</Col>
              <Col span={8} className={`col-grey`}>
                Kode Warna:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_color_code}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Warna:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_color_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Rangka:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_chassis_number}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Mesin:
              </Col>
              <Col span={16}>{this.state.dataDetailStock?.vehicle_engine_number}</Col>
            </Row>

            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Harga Kendaraan</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Harga Pembelian:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.vehicle_purchase_price)}</Col>
              <Col span={8} className={`col-grey`}>
                Discount:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.vehicle_purchase_discount)}</Col>
              <Col span={8} className={`col-grey`}>
                Harga Setelah Diskon:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.vehicle_basic_purchase_price)}</Col>
              <Col span={8} className={`col-grey`}>
                VAT:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.vehicle_purchase_vat)}</Col>
              <Col span={8} className={`col-grey`}>
                Harga Final Pembelian:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.vehicle_fixed_purchase_price)}</Col>
              <Col span={8} className={`col-grey`}>
                Harga Penjualan:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.vehicle_sales_price)}</Col>
              <Col span={8} className={`col-grey`}>
                DP Order:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.order_down_payment)}</Col>
              <Col span={8} className={`col-grey`}>
                Discount Order:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.order_discount)}</Col>
              <Col span={8} className={`col-grey`}>
                Repayment Leasing:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.leasing_repayment)}</Col>
              <Col span={8} className={`col-grey`}>
                Subsidi Leasing:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.leasing_subsidies)}</Col>
              <Col span={8} className={`col-grey`}>
                Estimasi Cost Transfer:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.transfer_title_cost_estimation)}</Col>
              <Col span={8} className={`col-grey`}>
                Real Cost Transfer:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.transfer_title_cost_real)}</Col>
              <Col span={8} className={`col-grey`}>
                Insentif Out:
              </Col>
              <Col span={16}>{currencyFormat(this.state.dataDetailStock?.incentive_out)}</Col>
            </Row>
            <br />
          </Modal>

          <Modal title="Konfirmasi Pembatalan Delivery" visible={this.state.confirmDeleteVisible} onOk={this.confirmOk} onCancel={this.confirmCancel} confirmLoading={this.state.confirmLoading}>
            <p>
              Anda Yakin Akan membatalkan Delivery Order <br /> {this.state.confirmText} ?
            </p>
          </Modal>

          <Modal title="Konfirmasi Kirim Data Ulang" visible={this.state.confirmResendVisible} onOk={this.confirmResendOk} onCancel={this.confirmCancel} confirmLoading={this.state.confirmLoading}>
            <p>
              Anda Yakin Akan Kirim Data Ulang <br /> {this.state.confirmResendText} ?
            </p>
          </Modal>

          <Modal visible={this.state.showModalImage} footer={null} onCancel={() => this.configModalImage(false, "")}>
            <img src={this.state.modalImageUrl} alt="Zoom" style={{ width: "100%" }} />
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(ListDeliveryOrder), 10);
